// src/services/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDwDBwH1f7Y7hs0HcyM_bPmW8FB5wS2D5w",
  authDomain: "tombolive-prod.firebaseapp.com",
  projectId: "tombolive-prod",
  storageBucket: "tombolive-prod.appspot.com",
  messagingSenderId: "444661145842",
  appId: "1:444661145842:web:318469e6b03db1a994306b"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export default app;
